/* eslint-disable max-lines */
import { ChatBotEmail } from 'pages/chatBotEmail'
import { Download, WellhubDownload } from 'pages/download'
import {
  Email,
  EmailConsent,
  EmailVariant2,
  LikeChatEmail,
  LikeChatEmailConsent,
} from 'pages/email'
import { FinishingTouches } from 'pages/finishingTouches'
import {
  IntroGiftCard,
  IntroInfluencers,
  IntroLikeChat,
  IntroPlan,
  IntroVariant1,
  IntroVariantRefund,
  LoadingIntro,
  LoadingIntro2,
  LoadingIntro3,
} from 'pages/intro'
import { ProviderAppVsBuilder } from 'pages/provider'
import {
  Age,
  AgeAsIntroProvider,
  AgeAsIntroWithImages,
  AgeForIntroPlan,
  AgeRelatedChanges,
  AgeWithImages,
  AgeWithImages2,
  AllRoundApproach,
  AlmostThere,
  AnalyzingAnswers,
  AnalyzingAnswersVariant2,
  BeautySolutionsConcerns,
  BiggestMotivation,
  CareCosmetics,
  CareCosmetics3,
  ChatStatementQuestion,
  CosmetologistVsLuvly,
  CreatingSculptingPlan,
  CustomizeGiftCard,
  DailyWater,
  DailyWaterVariant2,
  Diet,
  DietVariant2,
  DoubleChin,
  DoubleChinCause,
  DoubleChinChanges,
  DoubleChinConcerns,
  DoubleChinLifestyle,
  DoubleChinPeriod,
  DoubleChinReduction,
  DoubleChinTreating,
  EatingPatterns,
  EmbracingAge,
  ExpertLoader,
  FaceChangesCauses,
  FaceShape,
  FaceShapeChange,
  FaceYogaExperts,
  FaceYogaExpertsVariant2,
  FaceYogaRoutine,
  FrustratingDoubleChin,
  FrustratingReasons,
  Gender,
  GenderV2,
  GettingRidDoubleChin,
  GiftCardPaywall,
  GoalVariant2,
  GoalVariant3,
  GoalVariant4,
  HeardAboutYoga,
  HeardAboutYogaForIntroPlan,
  HolisticPlan,
  IdentifySkinColor,
  IntroSaleAgeAsIntro,
  LikeChatAge,
  LikeChatAnalyzingAnswers,
  LikeChatCareCosmetics,
  LikeChatChallenges1,
  LikeChatChallenges2,
  LikeChatDiet,
  LikeChatEatingPatterns,
  LikeChatExercises,
  LikeChatFaceYoga,
  LikeChatGoal,
  LikeChatMentalHealth,
  LikeChatMotivation,
  LikeChatNutritionFeedback,
  LikeChatPracticeDuration,
  LikeChatProblematicAreas,
  LikeChatSkinCareRoutine,
  LikeChatSkinConcerns,
  LikeChatSkinQuality,
  LikeChatSkinType,
  LikeChatSugar,
  LikeChatVegetables,
  LuvlyGuide,
  LuvlyUsers,
  ManageStressLevels,
  MenstrualCycle,
  MentalHealth,
  Motivation,
  NaturalFacialPractice,
  ObTags,
  PersonalizedPlan,
  PersonalizedProgram,
  PhotoResult,
  PracticeDuration,
  PracticeDurationVariant2,
  PreferredFood,
  PreliminaryProgress,
  PreparePlan,
  ProblematicAreas,
  ProblematicAreasV2,
  ProductIngredientFeedback,
  ReduceYourDoubleChin,
  RegularExercise,
  ReverseYourWrinkles,
  ReverseYourWrinkles3,
  SatisfyWithSkinCondition,
  ScannerFeedback,
  ShareGiftCard,
  ShortProgramDescription,
  SignsOfAging,
  SkinCareAndDiet,
  SkinCareRoutine,
  SkinCareRoutineDescription,
  SkinConcerns,
  SkinConcernsVariant2,
  SkinConcernsVariant4,
  SkinSensitivity,
  SkinType,
  SkinTypeExplanation,
  SkinTypeVariant2,
  SkincareChallenges,
  SleepHabits,
  SocialProof,
  StatementQuestion,
  StatementQuestionVariant2,
  StressLevel,
  StressLevels,
  Sugar,
  SunSafety,
  ThankForSharing,
  TimeToInvest,
  TrustFeedback,
  UselessProducts,
  Vegetables,
  VisitToCosmetologist,
  WeWantYouLookBest,
  WeWantYouLookBest2,
  WelcomeToLuvly,
  WhatIsFaceYoga,
  WonderfulStart,
  YouAreBeautiful,
  YouAreInGoodHands,
  YouAreInGoodHandsVariant2,
} from 'pages/questions'
import {
  FaceScan,
  FaceScanPreview,
  FaceScanResults,
  Recommendations,
  SkinDiagnosisIntro,
} from 'pages/skinDiagnosis'

import { Login, WellhubLogin } from 'modules/login'
import {
  CancelOfferQuestion,
  HolidayGift,
  PurchaseCosmeticScanner,
  PurchaseIntroFastProvider,
  PurchaseRefund,
  PurchaseUpgrade,
  PurchaseVariant2,
  PurchaseVariant7,
  PurchaseVariant8,
  SpecialPurchaseCancelOffer,
  UpsellCoaching,
  UpsellPaywallSwitchers,
  UpsellWellnessBundle,
} from 'modules/purchase/pages'
import { PurchaseUpgradePDF } from 'modules/purchase/pages/PurchaseUpgradePDF'

import { IDynamicPage, TIdToPageMap } from 'models/common.model'

import { Cohort, PINNED_PROGRESS_BAR_WITH_NAVIGATION } from 'root-constants'

export const enum PageId {
  INTRO = 'intro',
  GOAL = 'goal',
  GOAL_VARIANT_2 = 'goalVariant2',
  GOAL_VARIANT_3 = 'goalVariant3',
  GOAL_VARIANT_4 = 'goalVariant4',
  HAVE_YOU_HEARD = 'haveYouHeard',
  HAVE_YOU_HEARD_FOR_INTRO_PLAN = 'haveYouHeardForIntroPlan',
  WHAT_IS_FACE_YOGA = 'whatIsFaceYoga',
  SATISFY_WITH_SKIN_CONDITION = 'satisfyWithSkinCondition',
  SKIN_CARE_ROUTINE = 'skinCareRoutine',
  SKIN_CARE_AND_DIET = 'skinCareAndDiet',
  CARE_COSMETICS = 'careCosmetics',
  CARE_COSMETICS_3 = 'careCosmetics3',
  SUN_SAFETY = 'sunSafety',
  VISIT_TO_COSMETOLOGIST = 'visitToCosmetologist',
  COSMETOLOGIST_VS_LUVLY = 'cosmetologistVsLuvly',
  TARGET_GOAL = 'targetGoal',
  OB_TAGS = 'obTags',
  EATING_PATTERNS = 'eatingPatterns',
  DIET = 'diet',
  DIET_VARIANT_2 = 'dietVariant2',
  SUGAR = 'sugar',
  VEGETABLES = 'vegetables',
  DAILY_WATER = 'dailyWater',
  DAILY_WATER_VARIANT_2 = 'dailyWaterVariant2',
  GENDER = 'gender',
  GENDER_VARIANT_2 = 'genderVariant2',
  PERSONALIZED_PROGRAM = 'personalizedProgram',
  USERS_STATEMENT = 'usersStatement',
  PHOTO_RESULT = 'photoResult',
  ALMOST_THERE = 'almostThere',
  WELCOME_TO_LUVLY = 'welcomeToLuvly',
  WONDERFUL_START = 'wonderfulStart',
  YOU_ARE_BEAUTIFUL = 'youAreBeautiful',
  THANK_FOR_SHARING = 'thankForSharing',
  NO_DESIRED_RESULT = 'noDesiredResult',
  NOT_GREAT_RESULTS = 'notGreatResults',
  MAKE_ME_LOOK_HEAVIER = 'makeMeLookHeavier',
  NOT_REFLECT_FEELINGS = 'notReflectFeeling',
  WE_WANT_YOU_LOOK_BEST = 'weWantYouLookBest',
  WE_WANT_YOU_LOOK_BEST_2 = 'weWantYouLookBest2',
  NATURAL_FACIAL_PRACTICE = 'naturalFacialPractice',
  SOCIAL_PROOF = 'socialProof',
  SKINCARE_CHALLENGES = 'skincareChallenges',
  AGE = 'age',
  AGE_WITH_IMAGES = 'ageWithImages',
  AGE_WITH_IMAGES_2 = 'ageWithImages2',
  AGE_FOR_INTRO_PLAN = 'ageForIntroPlan',
  DOUBLE_CHIN = 'doubleChin',
  DOUBLE_CHIN_PERIOD = 'doubleChinPeriod',
  DOUBLE_CHIN_CAUSE = 'doubleChinCause',
  FRUSTRATING_DOUBLE_CHIN = 'frustratingDoubleChin',
  FRUSTRATING_REASONS = 'frustratingReasons',
  IDENTIFY_SKIN_COLOR = 'identifySkinColor',
  DOUBLE_CHIN_CHANGES = 'doubleChinChanges',
  STRESS_LEVELS = 'stressLevels',
  DOUBLE_CHIN_LIFESTYLE = 'doubleChinLifestyle',
  REGULAR_EXERCISE = 'regularExercise',
  AGE_AS_INTRO = 'ageAsIntro',
  AGE_AS_INTRO_WITH_IMAGES = 'ageAsIntroWithImages',
  LIKE_CHAT_INTRO = 'startChat',
  INTRO_REFUND = 'introRefund',
  INTRO_SALE_AGE = 'introSaleAge',
  LOADING_INTRO = 'loadingIntro',
  LOADING_INTRO_2 = 'loadingIntro2',
  LOADING_INTRO_3 = 'loadingIntro3',
  INTRO_INFLUENCERS = 'introInfluencers',
  INTRO_GIFT_CARD = 'giftCardIntro',
  INTRO_PLAN = 'introPlan',
  GIFT_CARD_PAYWALL = 'giftCardPaywall',
  DAILY_YOGA = 'dailyYoga',
  PROBLEMATIC_AREA = 'problematicArea',
  PROBLEMATIC_AREA_V3 = 'problematicAreaV3',
  PROBLEMATIC_AREA_INTERACTIVE = 'problematicAreaInteractive',
  SKIN_TYPE = 'skinType',
  SKIN_TYPE_EXPLANATION = 'skinTypeExplanation',
  SKIN_TYPE_VARIANT_2 = 'skinTypeVariant2',
  SKIN_CONCERNS = 'skinConcerns',
  SKIN_CONCERNS_VARIANT_2 = 'skinConcernsVariant2',
  SKIN_CONCERNS_VARIANT_4 = 'skinConcernsVariant4',
  SIGNS_OF_AGING = 'signsOfAging',
  GETTING_RID_DOUBLE_CHIN = 'gettingRidDoubleChin',
  TIME_TO_INVEST = 'timeToInvest',
  DOUBLE_CHIN_TREATMENT = 'doubleChinTreatment',
  DOUBLE_CHIN_CONCERNS = 'doubleChinConcerns',
  DOUBLE_CHIN_REDUCTION = 'doubleChinReduction',
  SLEEP_HABITS = 'sleepHabits',
  AGE_RELATED_CHANGES = 'ageRelatedChanges',
  SKIN_SENSITIVITY = 'skinSensitivity',
  MANAGE_STRESS_LEVELS = 'manageStressLevels',
  PRACTICE_DURATION_VARIANT_2 = 'practiceDurationV2',
  CREATING_SCULPTING_PLAN = 'creatingSculptingPlan',
  HOLISTIC_PLAN = 'holisticPlan',
  MOTIVATION = 'motivation',
  SHORT_PROGRAM_DESCRIPTION = 'shortProgramDescription',
  SKIN_CARE_ROUTINE_DESCRIPTION = 'skinCareRoutineDescription',
  PREFERRED_FOOD = 'preferredFood',
  PRACTICE_DURATION = 'practiceDuration',
  FACE_SHAPE = 'faceShape',
  BIGGEST_MOTIVATION = 'biggestMotivation',
  FACE_CHANGES_CAUSES = 'faceChangesCauses',
  EMBRACING_AGE = 'embracingAge',
  SKIN_REQUIRES_COMMITMENT = 'skinRequiresCommitment',
  HAPPINESS_IS_HABIT = 'happinessIsHabit',
  SKIN_DIAGNOSIS_INTRO = 'skinDiagnosisIntro',
  BEAUTY_SOLUTIONS_CONCERNS = 'beautySolutionsConcerns',
  FACE_SCAN_PREVIEW = 'faceScanPreview',
  FACE_SCAN = 'faceScan',
  FACE_SCAN_RESULTS = 'faceScanResults',
  FACE_YOGA_ROUTINE = 'faceYogaRoutine',
  ML_RECOMMENDATIONS = 'mlRecommendations',
  MIRROR_REFLECTION = 'mirrorReflection',
  COMPARE_MYSELF_TO_OTHERS = 'compareMyselfToOthers',
  APPEARANCE_EFFECT = 'appearanceEffect',
  AFRAID_TO_LOOK_OLDER = 'afraidToLookOlder',
  TO_BE_EXPERT = 'toBeExpert',
  COSMETICS_HELP = 'cosmeticsHelp',
  PRELIMINARY_PROGRESS = 'preliminaryProgress',
  SHORT_PROGRAM_DESCRIPTION_SECOND = 'shortProgramDescriptionSecond',
  MENSTRUAL_CYCLE = 'menstrualCycle',
  MENTAL_HEALTH = 'mentalHealth',
  PREPARE_PLAN = 'preparePlan',
  PERSONALIZED_PLAN = 'personalizedPlan',
  YOU_ARE_IN_GOOD_HANDS = 'youAreInGoodHands',
  YOU_ARE_IN_GOOD_HANDS_VARIANT_2 = 'youAreInGoodHandsV2',
  FACE_YOGA_EXPERTS = 'faceYogaExperts',
  FACE_YOGA_EXPERTS_VARIANT_2 = 'faceYogaExpertsVariant2',
  REVERSE_YOUR_WRINKLES = 'reverseYourWrinkles',
  REVERSE_YOUR_WRINKLES_3 = 'reverseYourWrinkles3',
  REDUCE_YOUR_DOUBLE_CHIN = 'reduceYourDoubleChin',
  ANALYZING_ANSWERS = 'analyzingAnswers',
  ANALYZING_ANSWERS_VARIANT_2 = 'analyzingAnswersVariant2',
  CUSTOMIZE_GIFT_CARD = 'customizeGiftCard',
  SHARE_GIFT_CARD = 'shareGiftCard',
  NAME = 'name',
  OB_LOADER = 'obLoader',
  OB_GOAL = 'obGoal',
  OB_AGE = 'obAge',
  OB_FACE_YOGA = 'obFaceYoga',
  OB_SKIN = 'obSkin',
  OB_AREAS = 'obAreas',
  OB_SKIN_TYPE = 'obSkinType',
  OB_ROUTINE = 'obRoutine',
  OB_PRODUCTS = 'obProducts',
  OB_CHALLENGES_1 = 'obChallenges1',
  OB_CHALLENGES_2 = 'obChallenges2',
  OB_SKIN_CONCERNS = 'obSkinConcerns',
  OB_EXERCISES = 'obExercises',
  OB_MEALS = 'obMeals',
  OB_DIET = 'obDiet',
  OB_SWEETS = 'obSweets',
  OB_VEGETABLES = 'obVegetables',
  OB_NUTRITION_FEEDBACK = 'obNutritionFeedback',
  OB_MENTAL_HEALTH = 'obMentalHealth',
  OB_STATEMENT_1 = 'obStatement1',
  OB_STATEMENT_2 = 'obStatement2',
  OB_STATEMENT_3 = 'obStatement3',
  OB_MOTIVATION = 'obMotivation',
  OB_SCHEDULE = 'obSchedule',
  OB_CREATING = 'obCreating',
  OB_EMAIL = 'obEmail',
  OB_EMAIL_CONSENT = 'obEmailConsent',
  OB_RESULT = 'obResult',
  ENTER_EMAIL = 'enterEmail',
  ENTER_EMAIL_VARIANT_2 = 'enterEmailV2',
  EMAIL_CONSENT = 'emailConsent',
  PURCHASE_EMAIL = 'purchaseEmail',
  PURCHASE_VARIANT_2 = 'purchaseVariant2',
  PURCHASE_VARIANT_7 = 'purchaseVariant7',
  PURCHASE = 'purchase',
  SPECIAL_PURCHASE_CANCEL_OFFER = 'specialPurchaseCancelOffer',
  PURCHASE_INTRO_CANCEL_OFFER = 'paywallCancelOffer',
  PURCHASE_INTRO_OFFER = 'purchaseIntroOffer',
  PURCHASE_REFUND_PROVIDER = 'purchaseRefundProvider',
  PURCHASE_REFUND = 'purchaseRefund',
  PURCHASE_COSMETIC_SCANNER = 'purchaseCosmeticScanner',
  PURCHASE_VARIANT_8 = 'purchaseVariant8',
  PURCHASE_UPGRADE = 'purchaseUpgrade',
  PURCHASE_UPGRADE_PDF = 'purchaseUpgradePDF',
  PURCHASE_RE_TARGETING = 'purchaseReTargeting',
  CANCEL_OFFER_QUESTION = 'cancelOfferQuestion',
  LIVECHAT_UPSELL_IN_APP = 'livechatUpsellInApp',
  LIVECHAT_UPSELL_CANCEL_IN_APP = 'livechatUpsellCancelInApp',
  UPSELL_PAYWALL = 'upsellPaywall',
  COACHING_PAYWALL = 'coachingPaywall',
  COACHING_CANCEL_PAYWALL = 'coachingCancelPaywall',
  WELLNESS_BUNDLE_PAYWALL = 'wellnessBundlePaywall',
  WELLNESS_BUNDLE_CANCEL_PAYWALL = 'wellnessBundleCancelPaywall',
  FINISHING_TOUCHES = 'finishingTouches',
  LOGIN = 'login',
  WELLHUB_LOGIN = 'wellhubLogin',
  DOWNLOAD = 'download',
  WELLHUB_DOWNLOAD = 'wellhubDownload',
  PROXY_TO_START = 'proxyToStart',
  PAYPAL_PROXY = 'paypalProxy',
  LUVLY_USERS = 'luvlyUsers',
  LUVLY_GUIDE = 'luvlyGuide',
  ALL_ROUND_APPROACH = 'allRoundApproach',
  FACE_SHAPE_CHANGE = 'faceShapeChange',
  PRODUCT_INGREDIENT_FEEDBACK = 'productIngredientFeedback',
  USELESS_PRODUCTS = 'uselessProducts',
  SCANNER_FEEDBACK = 'scannerFeedback',
  TRUST_FEEDBACK = 'trustFeedback',
  STRESS_LEVEL = 'stressLevel',
  TRAINING_DURATION = 'trainingDuration',
  PROVIDER_APP_VS_BUILDER = 'providerAppVsBuilder',
  HOLIDAY_GIFT = 'holidayGift',
}

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  stressLevel: StressLevel,
  intro: IntroVariant1,
  introRefund: IntroVariantRefund,
  introSaleAge: IntroSaleAgeAsIntro,
  introInfluencers: IntroInfluencers,
  giftCardIntro: IntroGiftCard,
  introPlan: IntroPlan,
  luvlyUsers: LuvlyUsers,
  luvlyGuide: LuvlyGuide,
  allRoundApproach: AllRoundApproach,
  haveYouHeard: HeardAboutYoga,
  haveYouHeardForIntroPlan: HeardAboutYogaForIntroPlan,
  whatIsFaceYoga: WhatIsFaceYoga,
  satisfyWithSkinCondition: SatisfyWithSkinCondition,
  skinCareRoutine: SkinCareRoutine,
  skinSensitivity: SkinSensitivity,
  careCosmetics: CareCosmetics,
  careCosmetics3: CareCosmetics3,
  sunSafety: SunSafety,
  trustFeedback: TrustFeedback,
  visitToCosmetologist: VisitToCosmetologist,
  cosmetologistVsLuvly: CosmetologistVsLuvly,
  eatingPatterns: EatingPatterns,
  diet: Diet,
  dietVariant2: DietVariant2,
  dailyYoga: PracticeDurationVariant2,
  sugar: Sugar,
  vegetables: Vegetables,
  dailyWater: DailyWater,
  dailyWaterVariant2: DailyWaterVariant2,
  gender: Gender,
  genderVariant2: GenderV2,
  almostThere: AlmostThere,
  welcomeToLuvly: WelcomeToLuvly,
  wonderfulStart: WonderfulStart,
  youAreBeautiful: YouAreBeautiful,
  thankForSharing: ThankForSharing,
  naturalFacialPractice: NaturalFacialPractice,
  socialProof: SocialProof,
  skincareChallenges: SkincareChallenges,
  skinCareAndDiet: SkinCareAndDiet,
  gettingRidDoubleChin: GettingRidDoubleChin,
  timeToInvest: TimeToInvest,
  doubleChinTreatment: DoubleChinTreating,
  doubleChinConcerns: DoubleChinConcerns,
  doubleChinReduction: DoubleChinReduction,
  sleepHabits: SleepHabits,
  practiceDurationV2: PracticeDurationVariant2,
  photoResult: PhotoResult,
  productIngredientFeedback: ProductIngredientFeedback,
  age: Age,
  doubleChin: DoubleChin,
  doubleChinPeriod: DoubleChinPeriod,
  identifySkinColor: IdentifySkinColor,
  biggestMotivation: BiggestMotivation,
  faceChangesCauses: FaceChangesCauses,
  embracingAge: EmbracingAge,
  ageWithImages: AgeWithImages,
  ageWithImages2: AgeWithImages2,
  ageForIntroPlan: AgeForIntroPlan,
  ageAsIntroWithImages: AgeAsIntroWithImages,
  frustratingDoubleChin: FrustratingDoubleChin,
  frustratingReasons: FrustratingReasons,
  doubleChinCause: DoubleChinCause,
  doubleChinChanges: DoubleChinChanges,
  stressLevels: StressLevels,
  manageStressLevels: ManageStressLevels,
  ageRelatedChanges: AgeRelatedChanges,
  regularExercise: RegularExercise,
  doubleChinLifestyle: DoubleChinLifestyle,
  creatingSculptingPlan: CreatingSculptingPlan,
  weWantYouLookBest: WeWantYouLookBest,
  weWantYouLookBest2: WeWantYouLookBest2,
  beautySolutionsConcerns: BeautySolutionsConcerns,
  ageAsIntro: AgeAsIntroProvider,
  personalizedPlan: PersonalizedPlan,
  loadingIntro: LoadingIntro,
  loadingIntro2: LoadingIntro2,
  loadingIntro3: LoadingIntro3,
  startChat: IntroLikeChat,
  uselessProducts: UselessProducts,
  goalVariant2: GoalVariant2,
  goalVariant3: GoalVariant3,
  goalVariant4: GoalVariant4,
  problematicArea: ProblematicAreas,
  personalizedProgram: PersonalizedProgram,
  problematicAreaInteractive: ProblematicAreasV2,
  skinType: SkinType,
  skinTypeVariant2: SkinTypeVariant2,
  skinTypeExplanation: SkinTypeExplanation,
  skinConcerns: SkinConcerns,
  skinConcernsVariant2: SkinConcernsVariant2,
  skinConcernsVariant4: SkinConcernsVariant4,
  motivation: Motivation,
  shortProgramDescription: ShortProgramDescription,
  skinCareRoutineDescription: SkinCareRoutineDescription,
  preferredFood: PreferredFood,
  practiceDuration: PracticeDuration,
  faceShape: FaceShape,
  faceYogaRoutine: FaceYogaRoutine,
  holisticPlan: HolisticPlan,
  faceShapeChange: FaceShapeChange,
  skinDiagnosisIntro: SkinDiagnosisIntro,
  faceScanPreview: FaceScanPreview,
  faceScan: FaceScan,
  faceScanResults: FaceScanResults,
  scannerFeedback: ScannerFeedback,
  signsOfAging: SignsOfAging,
  mlRecommendations: Recommendations,
  mirrorReflection: StatementQuestion,
  skinRequiresCommitment: StatementQuestion,
  compareMyselfToOthers: StatementQuestion,
  appearanceEffect: StatementQuestion,
  afraidToLookOlder: StatementQuestion,
  toBeExpert: StatementQuestion,
  cosmeticsHelp: StatementQuestion,
  happinessIsHabit: StatementQuestion,
  noDesiredResult: StatementQuestionVariant2,
  notGreatResults: StatementQuestionVariant2,
  makeMeLookHeavier: StatementQuestionVariant2,
  notReflectFeeling: StatementQuestionVariant2,
  obLoader: ExpertLoader,
  obGoal: LikeChatGoal,
  obAge: LikeChatAge,
  obFaceYoga: LikeChatFaceYoga,
  obSkin: LikeChatSkinQuality,
  obAreas: LikeChatProblematicAreas,
  obExercises: LikeChatExercises,
  obSkinType: LikeChatSkinType,
  obRoutine: LikeChatSkinCareRoutine,
  obProducts: LikeChatCareCosmetics,
  obChallenges1: LikeChatChallenges1,
  obChallenges2: LikeChatChallenges2,
  obSkinConcerns: LikeChatSkinConcerns,
  obMeals: LikeChatEatingPatterns,
  obDiet: LikeChatDiet,
  obSweets: LikeChatSugar,
  obVegetables: LikeChatVegetables,
  obNutritionFeedback: LikeChatNutritionFeedback,
  obMentalHealth: LikeChatMentalHealth,
  obStatement1: ChatStatementQuestion,
  obStatement2: ChatStatementQuestion,
  obStatement3: ChatStatementQuestion,
  obMotivation: LikeChatMotivation,
  obSchedule: LikeChatPracticeDuration,
  obCreating: LikeChatAnalyzingAnswers,
  preliminaryProgress: PreliminaryProgress,
  shortProgramDescriptionSecond: ShortProgramDescription,
  menstrualCycle: MenstrualCycle,
  mentalHealth: MentalHealth,
  preparePlan: PreparePlan,
  youAreInGoodHands: YouAreInGoodHands,
  youAreInGoodHandsV2: YouAreInGoodHandsVariant2,
  faceYogaExperts: FaceYogaExperts,
  faceYogaExpertsVariant2: FaceYogaExpertsVariant2,
  reverseYourWrinkles: ReverseYourWrinkles,
  reverseYourWrinkles3: ReverseYourWrinkles3,
  reduceYourDoubleChin: ReduceYourDoubleChin,
  obTags: ObTags,
  analyzingAnswers: AnalyzingAnswers,
  analyzingAnswersVariant2: AnalyzingAnswersVariant2,
  customizeGiftCard: CustomizeGiftCard,
  giftCardPaywall: GiftCardPaywall,
  shareGiftCard: ShareGiftCard,
  obEmail: LikeChatEmail,
  obEmailConsent: LikeChatEmailConsent,
  enterEmail: Email,
  enterEmailV2: EmailVariant2,
  emailConsent: EmailConsent,
  chatBotEmail: ChatBotEmail,
  purchaseEmail: PurchaseVariant2,
  purchaseVariant2: PurchaseVariant2,
  purchaseVariant7: PurchaseVariant7,
  purchaseCosmeticScanner: PurchaseCosmeticScanner,
  purchaseRefund: PurchaseRefund,
  cancelOfferQuestion: CancelOfferQuestion,
  specialPurchaseCancelOffer: SpecialPurchaseCancelOffer,
  paywallCancelOffer: PurchaseIntroFastProvider,
  purchaseIntroOffer: PurchaseIntroFastProvider,
  purchaseVariant8: PurchaseVariant8,
  purchaseUpgrade: PurchaseUpgrade,
  purchaseUpgradePDF: PurchaseUpgradePDF,
  upsellPaywall: UpsellPaywallSwitchers,
  coachingPaywall: UpsellCoaching,
  coachingCancelPaywall: UpsellCoaching,
  wellnessBundlePaywall: UpsellWellnessBundle,
  wellnessBundleCancelPaywall: UpsellWellnessBundle,
  finishingTouches: FinishingTouches,
  login: Login,
  wellhubLogin: WellhubLogin,
  download: Download,
  wellhubDownload: WellhubDownload,
  providerAppVsBuilder: ProviderAppVsBuilder,
  holidayGift: HolidayGift,
}

export const DYNAMIC_PAGES_SET_VARIANT_1: IDynamicPage[] = [
  { id: PageId.INTRO },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.WHAT_IS_FACE_YOGA },
  { id: PageId.SATISFY_WITH_SKIN_CONDITION },
  { id: PageId.SKIN_CARE_ROUTINE },
  { id: PageId.CARE_COSMETICS },
  { id: PageId.SUN_SAFETY },
  { id: PageId.VISIT_TO_COSMETOLOGIST },
  { id: PageId.COSMETOLOGIST_VS_LUVLY },
  { id: PageId.EATING_PATTERNS },
  { id: PageId.DIET },
  { id: PageId.SUGAR },
  { id: PageId.VEGETABLES },
  { id: PageId.DAILY_WATER },
  { id: PageId.GENDER },
  { id: PageId.PHOTO_RESULT },
  { id: PageId.AGE },
  { id: PageId.PROBLEMATIC_AREA },
  { id: PageId.SKIN_TYPE },
  { id: PageId.SKIN_TYPE_EXPLANATION },
  { id: PageId.SKIN_CONCERNS },
  { id: PageId.SKIN_DIAGNOSIS_INTRO },
  { id: PageId.FACE_SCAN },
  { id: PageId.ML_RECOMMENDATIONS },
  { id: PageId.MOTIVATION },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION },
  { id: PageId.SKIN_CARE_ROUTINE_DESCRIPTION },
  { id: PageId.PREFERRED_FOOD },
  { id: PageId.PRACTICE_DURATION },
  { id: PageId.FACE_SHAPE },
  { id: PageId.MIRROR_REFLECTION },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.APPEARANCE_EFFECT },
  { id: PageId.AFRAID_TO_LOOK_OLDER },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PRELIMINARY_PROGRESS },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION_SECOND },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.PREPARE_PLAN },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_2: IDynamicPage[] = [
  { id: PageId.INTRO_REFUND },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.WHAT_IS_FACE_YOGA },
  { id: PageId.SATISFY_WITH_SKIN_CONDITION },
  { id: PageId.OB_TAGS },
  { id: PageId.SKIN_CARE_ROUTINE },
  { id: PageId.CARE_COSMETICS },
  { id: PageId.SUN_SAFETY },
  { id: PageId.VISIT_TO_COSMETOLOGIST },
  { id: PageId.COSMETOLOGIST_VS_LUVLY },
  { id: PageId.EATING_PATTERNS },
  { id: PageId.DIET },
  { id: PageId.SUGAR },
  { id: PageId.VEGETABLES },
  { id: PageId.DAILY_WATER },
  { id: PageId.GENDER },
  { id: PageId.PHOTO_RESULT },
  { id: PageId.AGE },
  { id: PageId.PROBLEMATIC_AREA },
  { id: PageId.SKIN_TYPE },
  { id: PageId.SKIN_TYPE_EXPLANATION },
  { id: PageId.SKIN_CONCERNS },
  { id: PageId.SKIN_DIAGNOSIS_INTRO },
  { id: PageId.FACE_SCAN },
  { id: PageId.ML_RECOMMENDATIONS },
  { id: PageId.MOTIVATION },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION },
  { id: PageId.SKIN_CARE_ROUTINE_DESCRIPTION },
  { id: PageId.PREFERRED_FOOD },
  { id: PageId.PRACTICE_DURATION },
  { id: PageId.FACE_SHAPE },
  { id: PageId.MIRROR_REFLECTION },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.APPEARANCE_EFFECT },
  { id: PageId.AFRAID_TO_LOOK_OLDER },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PRELIMINARY_PROGRESS },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION_SECOND },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.PREPARE_PLAN },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_3: IDynamicPage[] = [
  { id: PageId.INTRO_INFLUENCERS },
  { id: PageId.AGE },
  { id: PageId.GOAL_VARIANT_2 },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.WHAT_IS_FACE_YOGA },
  { id: PageId.SATISFY_WITH_SKIN_CONDITION },
  { id: PageId.OB_TAGS },
  { id: PageId.SKIN_CARE_ROUTINE },
  { id: PageId.CARE_COSMETICS },
  { id: PageId.SUN_SAFETY },
  { id: PageId.VISIT_TO_COSMETOLOGIST },
  { id: PageId.COSMETOLOGIST_VS_LUVLY },
  { id: PageId.EATING_PATTERNS },
  { id: PageId.DIET },
  { id: PageId.SUGAR },
  { id: PageId.VEGETABLES },
  { id: PageId.DAILY_WATER },
  { id: PageId.GENDER },
  { id: PageId.PHOTO_RESULT },
  { id: PageId.PROBLEMATIC_AREA },
  { id: PageId.SKIN_TYPE },
  { id: PageId.SKIN_TYPE_EXPLANATION },
  { id: PageId.SKIN_CONCERNS },
  { id: PageId.SKIN_DIAGNOSIS_INTRO },
  { id: PageId.FACE_SCAN },
  { id: PageId.ML_RECOMMENDATIONS },
  { id: PageId.MOTIVATION },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION },
  { id: PageId.SKIN_CARE_ROUTINE_DESCRIPTION },
  { id: PageId.PREFERRED_FOOD },
  { id: PageId.PRACTICE_DURATION },
  { id: PageId.FACE_SHAPE },
  { id: PageId.MIRROR_REFLECTION },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.APPEARANCE_EFFECT },
  { id: PageId.AFRAID_TO_LOOK_OLDER },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PRELIMINARY_PROGRESS },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION_SECOND },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.PREPARE_PLAN },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_4: IDynamicPage[] = [
  { id: PageId.INTRO_GIFT_CARD },
  {
    id: PageId.CUSTOMIZE_GIFT_CARD,
    hasProgressBar: true,
    progressValue: 1,
  },
  {
    id: PageId.GIFT_CARD_PAYWALL,
    hasProgressBar: true,
    progressValue: 2,
  },
  {
    id: PageId.SHARE_GIFT_CARD,
    hasProgressBar: true,
    progressValue: 3,
  },
]

export const DYNAMIC_PAGES_SET_VARIANT_6: IDynamicPage[] = [
  { id: PageId.LOADING_INTRO },
  {
    id: PageId.DOUBLE_CHIN,
    progressValue: 1,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.GENDER_VARIANT_2,
    progressValue: 2,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_WITH_IMAGES,
    progressValue: 3,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_TYPE_VARIANT_2,
    progressValue: 4,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.IDENTIFY_SKIN_COLOR,
    progressValue: 5,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_RELATED_CHANGES,
    progressValue: 6,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_CAUSE,
    progressValue: 7,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DIET_VARIANT_2,
    progressValue: 8,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DAILY_WATER_VARIANT_2,
    progressValue: 9,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_CONCERNS_VARIANT_2,
    progressValue: 10,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SIGNS_OF_AGING,
    progressValue: 11,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FACE_YOGA_ROUTINE,
    progressValue: 12,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NO_DESIRED_RESULT,
    progressValue: 13,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NOT_GREAT_RESULTS,
    progressValue: 14,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.MAKE_ME_LOOK_HEAVIER,
    progressValue: 15,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NOT_REFLECT_FEELINGS,
    progressValue: 16,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.WE_WANT_YOU_LOOK_BEST,
    progressValue: 17,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_TREATMENT,
    progressValue: 18,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.GETTING_RID_DOUBLE_CHIN,
    progressValue: 19,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_CONCERNS,
    progressValue: 20,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.TIME_TO_INVEST,
    progressValue: 21,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_REDUCTION,
    progressValue: 22,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.MANAGE_STRESS_LEVELS,
    progressValue: 23,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_LIFESTYLE,
    progressValue: 24,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SLEEP_HABITS,
    progressValue: 25,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.CREATING_SCULPTING_PLAN,
    progressValue: 26,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PRACTICE_DURATION_VARIANT_2,
    progressValue: 27,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.YOU_ARE_IN_GOOD_HANDS_VARIANT_2,
    progressValue: 28,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FACE_YOGA_EXPERTS_VARIANT_2,
    progressValue: 29,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.REDUCE_YOUR_DOUBLE_CHIN,
    progressValue: 30,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ANALYZING_ANSWERS_VARIANT_2,
    progressValue: 31,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ENTER_EMAIL_VARIANT_2,
    progressValue: 32,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
]

export const DYNAMIC_PAGES_SET_VARIANT_7: IDynamicPage[] = [
  { id: PageId.AGE_AS_INTRO },
  { id: PageId.GOAL_VARIANT_2 },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.WHAT_IS_FACE_YOGA },
  { id: PageId.SATISFY_WITH_SKIN_CONDITION },
  { id: PageId.OB_TAGS },
  { id: PageId.SKIN_CARE_ROUTINE },
  { id: PageId.CARE_COSMETICS },
  { id: PageId.SUN_SAFETY },
  { id: PageId.VISIT_TO_COSMETOLOGIST },
  { id: PageId.COSMETOLOGIST_VS_LUVLY },
  { id: PageId.EATING_PATTERNS },
  { id: PageId.DIET },
  { id: PageId.SUGAR },
  { id: PageId.VEGETABLES },
  { id: PageId.DAILY_WATER },
  { id: PageId.GENDER },
  { id: PageId.PHOTO_RESULT },
  { id: PageId.PROBLEMATIC_AREA },
  { id: PageId.SKIN_TYPE },
  { id: PageId.SKIN_TYPE_EXPLANATION },
  { id: PageId.SKIN_CONCERNS },
  { id: PageId.SKIN_DIAGNOSIS_INTRO },
  { id: PageId.FACE_SCAN },
  { id: PageId.ML_RECOMMENDATIONS },
  { id: PageId.MOTIVATION },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION },
  { id: PageId.SKIN_CARE_ROUTINE_DESCRIPTION },
  { id: PageId.PREFERRED_FOOD },
  { id: PageId.PRACTICE_DURATION },
  { id: PageId.FACE_SHAPE },
  { id: PageId.MIRROR_REFLECTION },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.APPEARANCE_EFFECT },
  { id: PageId.AFRAID_TO_LOOK_OLDER },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PRELIMINARY_PROGRESS },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION_SECOND },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.PREPARE_PLAN },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_8: IDynamicPage[] = [
  { id: PageId.INTRO },
  { id: PageId.LUVLY_USERS },
  { id: PageId.GENDER, hasProgressBar: true, progressValue: 1 },
  { id: PageId.AGE, hasProgressBar: true, progressValue: 2 },
  { id: PageId.SKIN_TYPE, hasProgressBar: true, progressValue: 3 },
  {
    id: PageId.SATISFY_WITH_SKIN_CONDITION,
    hasProgressBar: true,
    progressValue: 4,
  },
  { id: PageId.SKIN_CONCERNS, hasProgressBar: true, progressValue: 5 },
  { id: PageId.LUVLY_GUIDE },
  { id: PageId.SKIN_CARE_ROUTINE, hasProgressBar: true, progressValue: 6 },
  { id: PageId.CARE_COSMETICS, hasProgressBar: true, progressValue: 7 },
  { id: PageId.SUN_SAFETY, hasProgressBar: true, progressValue: 8 },
  { id: PageId.PRODUCT_INGREDIENT_FEEDBACK },
  { id: PageId.USELESS_PRODUCTS, hasProgressBar: true, progressValue: 9 },
  { id: PageId.SCANNER_FEEDBACK },
  { id: PageId.TRUST_FEEDBACK },
  { id: PageId.FACE_SHAPE_CHANGE },
  { id: PageId.PROBLEMATIC_AREA, hasProgressBar: true, progressValue: 10 },
  { id: PageId.MOTIVATION, hasProgressBar: true, progressValue: 11 },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.ALL_ROUND_APPROACH },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.SKIN_REQUIRES_COMMITMENT },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.TO_BE_EXPERT },
  { id: PageId.HAPPINESS_IS_HABIT },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PREPARE_PLAN },
  {
    id: PageId.SHORT_PROGRAM_DESCRIPTION,
    hasProgressBar: true,
    progressValue: 12,
  },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_9: IDynamicPage[] = [
  { id: PageId.LOADING_INTRO_2 },
  {
    id: PageId.GOAL_VARIANT_4,
    progressValue: 1,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FRUSTRATING_REASONS,
    progressValue: 2,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PERSONALIZED_PROGRAM,
    progressValue: 3,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.GENDER_VARIANT_2,
    progressValue: 4,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_WITH_IMAGES,
    progressValue: 5,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_TYPE_VARIANT_2,
    progressValue: 6,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.IDENTIFY_SKIN_COLOR,
    progressValue: 7,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_RELATED_CHANGES,
    progressValue: 8,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_SENSITIVITY,
    progressValue: 9,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_CONCERNS_VARIANT_2,
    progressValue: 10,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PROBLEMATIC_AREA_INTERACTIVE,
    progressValue: 11,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.BIGGEST_MOTIVATION,
    progressValue: 12,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FACE_CHANGES_CAUSES,
    progressValue: 13,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.EMBRACING_AGE,
    progressValue: 14,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DIET_VARIANT_2,
    progressValue: 15,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DAILY_WATER_VARIANT_2,
    progressValue: 16,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.WE_WANT_YOU_LOOK_BEST_2,
    progressValue: 17,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.BEAUTY_SOLUTIONS_CONCERNS,
    progressValue: 18,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_REDUCTION,
    progressValue: 19,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.MANAGE_STRESS_LEVELS,
    progressValue: 20,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_CARE_AND_DIET,
    progressValue: 21,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.REGULAR_EXERCISE,
    progressValue: 22,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DAILY_YOGA,
    progressValue: 23,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PREPARE_PLAN,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.YOU_ARE_IN_GOOD_HANDS_VARIANT_2,
    progressValue: 24,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.REDUCE_YOUR_DOUBLE_CHIN,
    progressValue: 25,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ANALYZING_ANSWERS_VARIANT_2,
    progressValue: 26,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ENTER_EMAIL_VARIANT_2,
    progressValue: 27,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
]

export const DYNAMIC_PAGES_SET_VARIANT_11: IDynamicPage[] = [
  {
    id: PageId.LOADING_INTRO_3,
  },
  {
    id: PageId.GENDER_VARIANT_2,
    progressValue: 1,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_WITH_IMAGES_2,
    progressValue: 2,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_TYPE_VARIANT_2,
    progressValue: 3,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_CONCERNS_VARIANT_4,
    progressValue: 4,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PROBLEMATIC_AREA_INTERACTIVE,
    progressValue: 5,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.CARE_COSMETICS_3,
    progressValue: 6,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.REVERSE_YOUR_WRINKLES_3,
    progressValue: 7,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ANALYZING_ANSWERS_VARIANT_2,
    progressValue: 8,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PERSONALIZED_PLAN,
    progressValue: 9,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.WELLHUB_LOGIN,
    progressValue: 10,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
]

export const DYNAMIC_PAGES_SET_VARIANT_13: IDynamicPage[] = [
  { id: PageId.AGE_AS_INTRO },
  {
    id: PageId.GENDER,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 2,
    hasMinimalisticHeader: true,
  },
  { id: PageId.SOCIAL_PROOF, hasMinimalisticHeader: true },
  { id: PageId.WELCOME_TO_LUVLY, hasMinimalisticHeader: true },
  {
    id: PageId.GOAL_VARIANT_2,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 5,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.OB_TAGS,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 6,
    hasMinimalisticHeader: true,
  },
  { id: PageId.WONDERFUL_START, hasMinimalisticHeader: true },
  {
    id: PageId.HAVE_YOU_HEARD,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 8,
    hasMinimalisticHeader: true,
  },
  { id: PageId.NATURAL_FACIAL_PRACTICE, hasMinimalisticHeader: true },
  {
    id: PageId.FACE_SHAPE,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 10,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.PROBLEMATIC_AREA,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 11,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SATISFY_WITH_SKIN_CONDITION,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 12,
    hasMinimalisticHeader: true,
  },
  { id: PageId.YOU_ARE_BEAUTIFUL, hasMinimalisticHeader: true },
  {
    id: PageId.SKIN_TYPE,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 14,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SKIN_TYPE_EXPLANATION,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 14,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SKIN_CONCERNS,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 15,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SKIN_CARE_ROUTINE,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 16,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.CARE_COSMETICS,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 17,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SKINCARE_CHALLENGES,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 18,
    hasMinimalisticHeader: true,
  },
  { id: PageId.THANK_FOR_SHARING, hasMinimalisticHeader: true },
  {
    id: PageId.EATING_PATTERNS,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 20,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.DIET,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 21,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SUGAR,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 22,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.VEGETABLES,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 23,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.PREFERRED_FOOD,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 24,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.DAILY_WATER,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 25,
    hasMinimalisticHeader: true,
  },
  { id: PageId.ALMOST_THERE, hasMinimalisticHeader: true },
  {
    id: PageId.MENTAL_HEALTH,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 27,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.SKIN_REQUIRES_COMMITMENT,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 28,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.COMPARE_MYSELF_TO_OTHERS,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 29,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.TO_BE_EXPERT,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 30,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.HAPPINESS_IS_HABIT,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 31,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.COSMETICS_HELP,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 32,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.MOTIVATION,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 33,
    hasMinimalisticHeader: true,
  },
  {
    id: PageId.PRACTICE_DURATION,
    hasNavigation: true,
    hasProgressBar: true,
    progressValue: 34,
    hasMinimalisticHeader: true,
  },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_SET_VARIANT_18: IDynamicPage[] = [
  { id: PageId.LIKE_CHAT_INTRO },
  { id: PageId.OB_LOADER },
  { id: PageId.OB_GOAL, hasProgressBar: true, progressValue: 3 },
  { id: PageId.OB_AGE, hasProgressBar: true, progressValue: 4 },
  { id: PageId.OB_FACE_YOGA, hasProgressBar: true, progressValue: 5 },
  { id: PageId.OB_SKIN, hasProgressBar: true, progressValue: 6 },
  { id: PageId.OB_AREAS, hasProgressBar: true, progressValue: 7 },
  { id: PageId.OB_EXERCISES, hasProgressBar: true, progressValue: 8 },
  { id: PageId.OB_SKIN_TYPE, hasProgressBar: true, progressValue: 9 },
  { id: PageId.OB_SKIN_CONCERNS, hasProgressBar: true, progressValue: 10 },
  { id: PageId.OB_ROUTINE, hasProgressBar: true, progressValue: 11 },
  { id: PageId.OB_PRODUCTS, hasProgressBar: true, progressValue: 12 },
  { id: PageId.OB_CHALLENGES_1, hasProgressBar: true, progressValue: 13 },
  { id: PageId.OB_CHALLENGES_2, hasProgressBar: true, progressValue: 13 },
  { id: PageId.OB_MEALS, hasProgressBar: true, progressValue: 14 },
  { id: PageId.OB_DIET, hasProgressBar: true, progressValue: 15 },
  { id: PageId.OB_SWEETS, hasProgressBar: true, progressValue: 16 },
  { id: PageId.OB_VEGETABLES, hasProgressBar: true, progressValue: 17 },
  { id: PageId.OB_NUTRITION_FEEDBACK, hasProgressBar: true, progressValue: 18 },
  { id: PageId.OB_MENTAL_HEALTH, hasProgressBar: true, progressValue: 19 },
  { id: PageId.OB_STATEMENT_1, hasProgressBar: true, progressValue: 20 },
  { id: PageId.OB_STATEMENT_2, hasProgressBar: true, progressValue: 21 },
  { id: PageId.OB_STATEMENT_3, hasProgressBar: true, progressValue: 22 },
  { id: PageId.OB_MOTIVATION, hasProgressBar: true, progressValue: 23 },
  { id: PageId.OB_SCHEDULE, hasProgressBar: true, progressValue: 24 },
  { id: PageId.OB_CREATING, hasProgressBar: true, progressValue: 25 },
  { id: PageId.OB_EMAIL, hasProgressBar: true, progressValue: 26 },
]

export const DYNAMIC_PAGES_SET_VARIANT_19: IDynamicPage[] = [
  { id: PageId.INTRO_SALE_AGE },
  {
    id: PageId.DOUBLE_CHIN,
    progressValue: 1,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.GENDER_VARIANT_2,
    progressValue: 2,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_TYPE_VARIANT_2,
    progressValue: 3,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.IDENTIFY_SKIN_COLOR,
    progressValue: 4,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.AGE_RELATED_CHANGES,
    progressValue: 5,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_CAUSE,
    progressValue: 6,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DIET_VARIANT_2,
    progressValue: 7,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DAILY_WATER_VARIANT_2,
    progressValue: 8,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SKIN_CONCERNS_VARIANT_2,
    progressValue: 9,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SIGNS_OF_AGING,
    progressValue: 10,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FACE_YOGA_ROUTINE,
    progressValue: 11,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NO_DESIRED_RESULT,
    progressValue: 12,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NOT_GREAT_RESULTS,
    progressValue: 13,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.MAKE_ME_LOOK_HEAVIER,
    progressValue: 14,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.NOT_REFLECT_FEELINGS,
    progressValue: 15,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.WE_WANT_YOU_LOOK_BEST,
    progressValue: 16,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_TREATMENT,
    progressValue: 17,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.GETTING_RID_DOUBLE_CHIN,
    progressValue: 18,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_CONCERNS,
    progressValue: 19,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.TIME_TO_INVEST,
    progressValue: 20,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_REDUCTION,
    progressValue: 21,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.MANAGE_STRESS_LEVELS,
    progressValue: 22,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.DOUBLE_CHIN_LIFESTYLE,
    progressValue: 23,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.SLEEP_HABITS,
    progressValue: 24,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.CREATING_SCULPTING_PLAN,
    progressValue: 25,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.PRACTICE_DURATION_VARIANT_2,
    progressValue: 26,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.YOU_ARE_IN_GOOD_HANDS_VARIANT_2,
    progressValue: 27,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.FACE_YOGA_EXPERTS_VARIANT_2,
    progressValue: 28,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.REDUCE_YOUR_DOUBLE_CHIN,
    progressValue: 29,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ANALYZING_ANSWERS_VARIANT_2,
    progressValue: 30,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
  {
    id: PageId.ENTER_EMAIL_VARIANT_2,
    progressValue: 31,
    ...PINNED_PROGRESS_BAR_WITH_NAVIGATION,
  },
]
export const DYNAMIC_PAGES_SET_VARIANT_21: IDynamicPage[] = [
  { id: PageId.INTRO_PLAN },
  { id: PageId.AGE_FOR_INTRO_PLAN },
  { id: PageId.GOAL_VARIANT_2 },
  { id: PageId.HAVE_YOU_HEARD_FOR_INTRO_PLAN },
  ...DYNAMIC_PAGES_SET_VARIANT_7.slice(3),
]
export const DYNAMIC_PAGES_SET_VARIANT_22: IDynamicPage[] = [
  { id: PageId.PROVIDER_APP_VS_BUILDER },
]
export const DYNAMIC_PAGES_SET_VARIANT_23: IDynamicPage[] = [
  { id: PageId.AGE_AS_INTRO_WITH_IMAGES },
  { id: PageId.GOAL_VARIANT_2 },
  { id: PageId.HAVE_YOU_HEARD },
  { id: PageId.WHAT_IS_FACE_YOGA },
  { id: PageId.SATISFY_WITH_SKIN_CONDITION },
  { id: PageId.OB_TAGS },
  { id: PageId.SKIN_CARE_ROUTINE },
  { id: PageId.CARE_COSMETICS },
  { id: PageId.SUN_SAFETY },
  { id: PageId.VISIT_TO_COSMETOLOGIST },
  { id: PageId.COSMETOLOGIST_VS_LUVLY },
  { id: PageId.EATING_PATTERNS },
  { id: PageId.DIET },
  { id: PageId.SUGAR },
  { id: PageId.VEGETABLES },
  { id: PageId.DAILY_WATER },
  { id: PageId.GENDER },
  { id: PageId.PHOTO_RESULT },
  { id: PageId.PROBLEMATIC_AREA },
  { id: PageId.SKIN_TYPE },
  { id: PageId.SKIN_TYPE_EXPLANATION },
  { id: PageId.SKIN_CONCERNS },
  { id: PageId.SKIN_DIAGNOSIS_INTRO },
  { id: PageId.FACE_SCAN },
  { id: PageId.ML_RECOMMENDATIONS },
  { id: PageId.MOTIVATION },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION },
  { id: PageId.SKIN_CARE_ROUTINE_DESCRIPTION },
  { id: PageId.PREFERRED_FOOD },
  { id: PageId.PRACTICE_DURATION },
  { id: PageId.FACE_SHAPE },
  { id: PageId.MIRROR_REFLECTION },
  { id: PageId.COMPARE_MYSELF_TO_OTHERS },
  { id: PageId.APPEARANCE_EFFECT },
  { id: PageId.AFRAID_TO_LOOK_OLDER },
  { id: PageId.COSMETICS_HELP },
  { id: PageId.PRELIMINARY_PROGRESS },
  { id: PageId.SHORT_PROGRAM_DESCRIPTION_SECOND },
  { id: PageId.MENSTRUAL_CYCLE },
  { id: PageId.MENTAL_HEALTH },
  { id: PageId.PREPARE_PLAN },
  { id: PageId.YOU_ARE_IN_GOOD_HANDS },
  { id: PageId.FACE_YOGA_EXPERTS },
  { id: PageId.REVERSE_YOUR_WRINKLES },
  { id: PageId.ANALYZING_ANSWERS },
  { id: PageId.ENTER_EMAIL },
]

export const DYNAMIC_PAGES_MAP = {
  [Cohort.QUIZ_2]: [DYNAMIC_PAGES_SET_VARIANT_1],
  [Cohort.LUVLY_INTRO_FAST]: [
    DYNAMIC_PAGES_SET_VARIANT_7,
    DYNAMIC_PAGES_SET_VARIANT_21,
  ],
  [Cohort.LUVLY_EMAIL_INTRO_FAST]: [DYNAMIC_PAGES_SET_VARIANT_7],
  [Cohort.LUVLY_CANCEL_INTRO_FAST]: [DYNAMIC_PAGES_SET_VARIANT_7],
  [Cohort.LUVLY_COSMETIC_SCANNER]: [DYNAMIC_PAGES_SET_VARIANT_8],
  [Cohort.LUVLY_CHAT]: [DYNAMIC_PAGES_SET_VARIANT_18],
  [Cohort.LUVLY_INTRO_SALE]: [DYNAMIC_PAGES_SET_VARIANT_7],
  [Cohort.LUVLY_INTRO4_SALE]: [DYNAMIC_PAGES_SET_VARIANT_7],
  [Cohort.LUVLY_REF]: [
    DYNAMIC_PAGES_SET_VARIANT_2,
    DYNAMIC_PAGES_SET_VARIANT_22,
  ],
  [Cohort.LUVLY_REF03]: [
    DYNAMIC_PAGES_SET_VARIANT_2,
    DYNAMIC_PAGES_SET_VARIANT_23,
  ],
  [Cohort.LUVLY_REF4_TT]: [DYNAMIC_PAGES_SET_VARIANT_2],
  [Cohort.LUVLY_REF4]: [DYNAMIC_PAGES_SET_VARIANT_2],
  [Cohort.LUVLY_AREF]: [DYNAMIC_PAGES_SET_VARIANT_2],
  [Cohort.LUVLY_PRINTABLE]: [DYNAMIC_PAGES_SET_VARIANT_2],
  [Cohort.LUVLY_CANCEL_INTRO_1]: [DYNAMIC_PAGES_SET_VARIANT_7],
  [Cohort.LUVLY_CHIN]: [
    DYNAMIC_PAGES_SET_VARIANT_19,
    DYNAMIC_PAGES_SET_VARIANT_6,
  ],
  [Cohort.LUVLY_INFLUENCERS]: [DYNAMIC_PAGES_SET_VARIANT_3],
  [Cohort.LUVLY_GIFT]: [DYNAMIC_PAGES_SET_VARIANT_4],
  [Cohort.LUVLY_WELLHUB]: [DYNAMIC_PAGES_SET_VARIANT_11],
}

export const EMAIL_CONSENT_PAGES_MAP: Record<string, PageId> = {
  [Cohort.QUIZ_2]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_EMAIL_7]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_INTRO_FAST]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_EMAIL_INTRO_FAST]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_CANCEL_INTRO_FAST]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_EMAIL_8]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_EMAIL_COACHING]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_EMAIL_SALE]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_COSMETIC_SCANNER]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_CHAT]: PageId.OB_EMAIL_CONSENT,
  [Cohort.LUVLY_REF]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_REF03]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_REF4_TT]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_REF4]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_CANCEL_INTRO_1]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_CHIN]: PageId.EMAIL_CONSENT,
  [Cohort.LUVLY_INFLUENCERS]: PageId.EMAIL_CONSENT,
}

export const EMAIL_CONSENT_PAGES: { id: PageId }[] = [
  { id: PageId.EMAIL_CONSENT },
  { id: PageId.OB_EMAIL_CONSENT },
]

export const PURCHASE_PAGES: { id: PageId; isProtected: boolean }[] = [
  { id: PageId.PURCHASE_EMAIL, isProtected: true },
  { id: PageId.PURCHASE_VARIANT_2, isProtected: true },
  { id: PageId.PURCHASE_INTRO_OFFER, isProtected: true },
  { id: PageId.PURCHASE_INTRO_CANCEL_OFFER, isProtected: true },
  { id: PageId.PURCHASE_COSMETIC_SCANNER, isProtected: true },
  { id: PageId.PURCHASE_REFUND, isProtected: true },
  { id: PageId.PURCHASE_VARIANT_8, isProtected: true },
  { id: PageId.CANCEL_OFFER_QUESTION, isProtected: true },
  { id: PageId.SPECIAL_PURCHASE_CANCEL_OFFER, isProtected: true },
  { id: PageId.HOLIDAY_GIFT, isProtected: true },
]

export const PURCHASE_PAGES_MAP: Record<Cohort, PageId> = {
  [Cohort.QUIZ_2]: PageId.PURCHASE_VARIANT_2,
  [Cohort.LUVLY_EMAIL_7]: PageId.PURCHASE_EMAIL,
  [Cohort.LUVLY_INTRO_FAST]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_CHAT_UPGRADE_12_PDF]: PageId.PURCHASE_VARIANT_2,
  [Cohort.LUVLY_CHAT_UPGRADE_12_EX_PDF]: PageId.PURCHASE_VARIANT_2,
  [Cohort.LUVLY_CHAT_UPGRADE_BUNDLE_PDF]: PageId.PURCHASE_VARIANT_2,
  [Cohort.LUVLY_EMAIL_8]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_EMAIL_SALE]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_EMAIL_COACHING]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_EMAIL_INTRO_FAST]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_CANCEL_INTRO_FAST]: PageId.PURCHASE_INTRO_CANCEL_OFFER,
  [Cohort.LUVLY_COSMETIC_SCANNER]: PageId.PURCHASE_COSMETIC_SCANNER,
  [Cohort.LUVLY_CHAT]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_INTRO_SALE]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_INTRO4_SALE]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_REF]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_REF03]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_REF4_TT]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_REF4]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_AREF]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_PRINTABLE]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_PRINTABLE_4]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_PRINTABLE_03]: PageId.PURCHASE_REFUND,
  [Cohort.LUVLY_CANCEL_INTRO_1]: PageId.PURCHASE_INTRO_CANCEL_OFFER,
  [Cohort.LUVLY_CHIN]: PageId.PURCHASE_VARIANT_8,
  [Cohort.LUVLY_INFLUENCERS]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_GIFT]: PageId.PURCHASE_INTRO_OFFER,
  [Cohort.LUVLY_WELLHUB]: PageId.PURCHASE_INTRO_OFFER,
}

export const UPSELL_PAGES_MAP: Record<Cohort, PageId[]> = {
  [Cohort.QUIZ_2]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_EMAIL_7]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_INTRO_FAST]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_EMAIL_8]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_EMAIL_SALE]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_EMAIL_INTRO_FAST]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_CANCEL_INTRO_FAST]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_EMAIL_COACHING]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
  ],
  [Cohort.LUVLY_CHAT]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_REF]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_REF03]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_AREF]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_REF4]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_REF4_TT]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_PRINTABLE]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_PRINTABLE_4]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_PRINTABLE_03]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_INTRO_SALE]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_INTRO4_SALE]: [
    PageId.COACHING_PAYWALL,
    PageId.COACHING_CANCEL_PAYWALL,
    PageId.UPSELL_PAYWALL,
  ],
  [Cohort.LUVLY_CHAT_UPGRADE_12_PDF]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_CHAT_UPGRADE_12_EX_PDF]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_CHAT_UPGRADE_BUNDLE_PDF]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_COSMETIC_SCANNER]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_CANCEL_INTRO_1]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_CHIN]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_INFLUENCERS]: [PageId.UPSELL_PAYWALL],
  [Cohort.LUVLY_GIFT]: [],
  [Cohort.LUVLY_WELLHUB]: [],
}
